export default __webpack_public_path__ + "static/media/ts_help3.677bbe87.png";